import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class UploadTermsConditionsService {

  constructor(private backendService:BackendService) { }
  private path = '/terms';

  save (data){
    return this.backendService.post (this.path , data);
  }

  
  getDashboard (){
    return this.backendService.get(this.path + "/condition/dashboard");
  }

  gettermsconditions(testid,langid) {    
    return this.backendService.get(this.path + '/tests/' + testid + "/langs/" + langid);
  }

 

  deleteTermsConditions(id) {    

    return this.backendService.get(this.path + '/delete/'+ id);
  }

  searchTermsConditions(currPage: number, pageSize: number, filter: any) {

    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);

  }
}
